import { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { NotificationBox } from '@eneco/sparky';
import { TextProps } from '@eneco/sparky/types';

import { Fields } from '../../types';
import type { FlowNotificationContent } from '../../types/content';
import { readField } from '../../utils/readField';
import { Header } from '../Header/Header';

export { STEP_TITLE_ID, getRadioGroupNameProps } from './radioGroupName';

/** The same three fields as `Fields`, without Sitecore's `{ value: … }` wrappers. */
export interface StepHeaderContent {
  content?: {
    title?: string;
    text?: string;
    notification?: FlowNotificationContent;
  };
}

interface Props {
  textualData?: Fields | StepHeaderContent;
  align?: TextProps['align'];
}

export const StepHeader: FC<Props> = ({ textualData, align = 'left' }) => {
  const content = textualData?.content;
  const title = readField<string>(content?.title);
  const text = readField<string>(content?.text);
  const notification = readField<FlowNotificationContent>(content?.notification);

  return (
    <>
      <Header align={align}>
        <Header.Title>{title}</Header.Title>
        {text && <Header.Text>{text}</Header.Text>}
      </Header>

      {notification?.content && (
        <NotificationBox
          isAlert={false}
          headingLevel="h2"
          variant={notification.variant}
          title={notification.title}
          text={<RichText html={notification.content} />}
        />
      )}
    </>
  );
};
